import React from 'react';
import _ from 'lodash';
import Inspectors from './Inspectors';
import Trainers from './Trainers';
import SiteAdmins from './SiteAdmins';
import Reports from './Reports';
import Modal from 'react-modal';
import { SlideDown } from 'react-slidedown'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-slidedown/lib/slidedown.css'
import 'react-tabs/style/react-tabs.css';
import './App.scss';

const AJAX_URL = window.wpApiSettings.fiq_ajax_url;
const INSPECTORS = window.wpApiSettings.fiq_inspectors;
const TRAINERS = window.wpApiSettings.fiq_trainers;
const SITEADMINS = window.wpApiSettings.fiq_siteadmins;
const USERROLE = window.wpApiSettings.fiq_current_user_role;
const modalStyles = {
	content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', },
	overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.85)', zIndex: 100000, }
};
Modal.setAppElement("#root");

class App extends React.Component {
	constructor() {
		super();

		// initial state
		this.state = {
			inspectors: INSPECTORS,
			inspectorsLoaded: [],
			inspectorsPage: 100,
			inspectorsIndex: 0,
			inspectorsSearch: false,
			loading: false,
			openInspector: false,
			trainers: TRAINERS,
			openTrainer: false,
			siteadmins: SITEADMINS,
			openSiteAdmin: false,
			fa_class: 'fa-chevron-down',
			modalIsOpen: false,
			new_user_success: false,
			new_user_error: false,
			new_user_error_msg: '',
		};

		// Create a ref for inspectors
		// this.inspectorsRef = React.createRef();
		// console.log("Ref created", this.inspectorsRef);

		this.filterInspectors = this.filterInspectors.bind(this);
		this.openCloseInspector = this.openCloseInspector.bind(this);

		this.filterTrainers = this.filterTrainers.bind(this);
		this.openCloseTrainer = this.openCloseTrainer.bind(this);

		this.filterSiteAdmins = this.filterSiteAdmins.bind(this);
		this.openCloseSiteAdmin = this.openCloseSiteAdmin.bind(this);

		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.addNewUser = this.addNewUser.bind(this);

		this.updateInspector = this.updateInspector.bind(this);
		this.updateTrainer = this.updateTrainer.bind(this);
		this.updateSiteAdmin = this.updateSiteAdmin.bind(this);

		this.loadMoreItems = this.loadMoreItems.bind(this);
	}

	componentDidMount() {
		if (!_.isEmpty(INSPECTORS)) { this.setState({ openInspector: INSPECTORS[0].id }); }
		if (!_.isEmpty(TRAINERS)) { this.setState({ openTrainer: TRAINERS[0].id }); }
		if (!_.isEmpty(SITEADMINS)) { this.setState({ openSiteAdmin: SITEADMINS[0].id }); }

		if (this.refs.inspectors){
			console.log(this.refs);
			this.refs.inspectors.addEventListener("scroll", () => {
				if (this.refs.inspectors.scrollTop + this.refs.inspectors.clientHeight >= this.refs.inspectors.scrollHeight - 20){
					this.loadMoreItems();
				}
			});
		}


		// setTimeout(() => {
		// 	console.log("Ref current", this.inspectorsRef.current);
		// 	if (this.inspectorsRef.current) {
		// 		this.inspectorsRef.current.addEventListener("scroll", this.handleScrollEvent);
		// 	}
		// }, 0);


		// setTimeout(() => {
		// 	if (this.inspectorsRef.current) {
		// 		this.inspectorsRef.current.addEventListener("scroll", () => {
		// 			// Use this.inspectorsRef.current instead of this.refs.inspectors
		// 			if (this.inspectorsRef.current.scrollTop + this.inspectorsRef.current.clientHeight >= this.inspectorsRef.current.scrollHeight - 20){
		// 				this.loadMoreItems();
		// 			}
		// 		});
		// 	}
		// }, 0);

		// if (this.refs.inspectors !== null){
		// 	this.refs.inspectors.addEventListener("scroll", () => {
		// 		if (this.refs.inspectors.scrollTop + this.refs.inspectors.clientHeight >= this.refs.inspectors.scrollHeight - 20){
		// 			this.loadMoreItems();
		// 		}
		// 	});
		// }

		document.addEventListener('DOMContentLoaded', () => {
			this.loadMoreItems();
		});
  }

	handleScrollEvent = () => {
		if (this.inspectorsRef.current.scrollTop + this.inspectorsRef.current.clientHeight >= this.inspectorsRef.current.scrollHeight - 20) {
			this.loadMoreItems();
		}
	};

  loadMoreItems() {
		var inspectorsTemp = [];
		var curIndex = this.state.inspectorsIndex;
		var searching = this.state.inspectorsSearch;
		var maxPage = this.state.inspectorsPage;
		var maxItems = this.state.inspectors.length;
		var limitItems = (curIndex + maxPage >= maxItems) ? maxItems: curIndex + maxPage;

		if (!searching) {
			if (curIndex < maxItems) {
				if(this.state.loading){ return; }
				this.setState({ loading: true });
				setTimeout(() => {
					for (var i = 0; i < limitItems; i++) { inspectorsTemp.push(this.state.inspectors[i]); }
					this.setState({ inspectorsLoaded: inspectorsTemp, inspectorsIndex: curIndex + maxPage, loading: false });
				}, 500);
			}
		}
  }

	filterInspectors(event) {
		var updatedUsers = INSPECTORS;
		var searchtemp = '';
		this.setState({ inspectorsSearch: true });
		event.persist();
		setTimeout(() => {
			updatedUsers = updatedUsers.filter(function (user) {
				searchtemp = user.first_name.toLowerCase() + user.last_name.toLowerCase();
				return searchtemp.search(event.target.value.toLowerCase()) !== -1;
			});
			if (event.target.value.length > 2) {
				if (updatedUsers.length == INSPECTORS.length){
					this.setState({ inspectorsSearch: false });
					this.setState({ inspectorsLoaded: [] });
					this.setState({ inspectorsIndex: 0 });
					this.loadMoreItems();
				} else {
					this.setState({ inspectorsLoaded: updatedUsers });
				}
			}
			if (event.target.value.length <= 2) {
				this.setState({ inspectorsSearch: false });
				this.setState({ inspectorsLoaded: [] });
				this.setState({ inspectorsIndex: 0 });
				this.loadMoreItems();
			}
		}, 500);
	}

	filterTrainers(event) {
		var updatedUsers = TRAINERS;
		var searchtemp = '';
		updatedUsers = updatedUsers.filter(function (user) {
			searchtemp = user.first_name.toLowerCase() + user.last_name.toLowerCase();
			return searchtemp.search(event.target.value.toLowerCase()) !== -1;
		});
		this.setState({ trainers: updatedUsers });
	}

	filterSiteAdmins(event) {
		var updatedUsers = SITEADMINS;
		var searchtemp = '';
		updatedUsers = updatedUsers.filter(function (user) {
			searchtemp = user.first_name.toLowerCase() + user.last_name.toLowerCase();
			return searchtemp.search(event.target.value.toLowerCase()) !== -1;
		});
		this.setState({ siteadmins: updatedUsers });
	}

	openCloseInspector(user) {
		if (this.state.openInspector != user) {
			this.setState({ openInspector: user });
		} else {
			this.setState({ openInspector: false });
		}
		return;
	}

	openCloseTrainer(user) {
		if (this.state.openTrainer != user) {
			this.setState({ openTrainer: user });
		} else {
			this.setState({ openTrainer: false });
		}
		return;
	}

	openCloseSiteAdmin(user) {
		if (this.state.openSiteAdmin != user) {
			this.setState({ openSiteAdmin: user });
		} else {
			this.setState({ openSiteAdmin: false });
		}
		return;
	}

	openModal() {
		this.setState({ modalIsOpen: true });
	}

	afterOpenModal() {

	}

	closeModal() {
		this.setState({ modalIsOpen: false });
		window.location.reload(true);
	}

	addNewUser(event) {
		let new_user = {
			user_role: event.target.elements.user_role.value,
			first_name: event.target.elements.first_name.value,
			last_name: event.target.elements.last_name.value,
			user_email: event.target.elements.user_email.value,
			company: event.target.elements.company.value,
			user_pass: Math.random().toString(36).slice(2),
		};

		if (!new_user.user_role || !new_user.first_name || !new_user.last_name || !new_user.user_email) {
			var error_temp = '';
			if (!new_user.user_role) { error_temp += "• User Type is Required\n"; }
			if (!new_user.first_name) { error_temp += "• First Name is Required\n" }
			if (!new_user.last_name) { error_temp += "• Last Name is Required\n" }
			if (!new_user.user_email) { error_temp += "• Email Address is Required\n" }
			alert("Cannot create new user!\nRequired info is missing for the following fields:\n\n" + error_temp);
		} else {
			fetch(AJAX_URL, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
				body: 'action=fiq_add_new_user&data=' + JSON.stringify(new_user),
				credentials: 'same-origin'
			}).then(data => {
				return data.json();
			}).then(data => {
				if (data == "success") {
					this.setState({ new_user_success: true });
					setTimeout(() => { this.closeModal(); }, 2500);
				} else {
					this.setState({ new_user_error: true });
					this.setState({ new_user_error_msg: data });
				}
			}).catch(error => console.log(error));
		}
		event.preventDefault();
	}

	updateInspector(user) {
		var tempArr = this.state.inspectors;
		var index = _.findIndex(tempArr, {id: user.id});
		tempArr[index] = user;
		this.setState({ inspectorsLoaded: tempArr });
	}

	updateTrainer(user) {
		var tempArr = this.state.trainers;
		var index = _.findIndex(tempArr, {id: user.id});
		tempArr[index] = user;
		this.setState({ trainers: tempArr });
	}

	updateSiteAdmin(user) {
		var tempArr = this.state.siteadmins;
		var index = _.findIndex(tempArr, {id: user.id});
		tempArr[index] = user;
		this.setState({ siteadmins: tempArr });
	}

	render() {
		return (
			<div className='fiq-cert-manager'>
				<h1>Certificate Manager</h1>
				<div>
					<Tabs defaultIndex={0}>
						<TabList className={`react-tabs__tab-list ${USERROLE}`}>
							{(USERROLE == "administrator" || USERROLE == "siteadmin" || USERROLE == "trainer" || USERROLE == "inspector") && (
								<Tab>Inspector</Tab>
							)}
							{(USERROLE == "administrator" || USERROLE == "siteadmin") && (
								<Tab>Site Admins</Tab>
							)}
							{(USERROLE == "administrator" || USERROLE == "trainer") && (
								<Tab>Trainers</Tab>
							)}
							{USERROLE == "administrator" && (
								<Tab>Reports</Tab>
							)}
						</TabList>
						{(USERROLE == "administrator" || USERROLE == "siteadmin" || USERROLE == "trainer" || USERROLE == "inspector") && (
							<TabPanel>
								<div style={{ maxWidth: 1000 }}>
									<div className="filter-list">
										<h3>Inspectors</h3>
										{(USERROLE == "administrator") && (
											<input type='button' value='Create New Inspector' className='button button-secondary create-user' onClick={() => this.openModal()} />
										)}
										<input type="text" placeholder="Search" className="search-box" onChange={this.filterInspectors} />
										{_.isEmpty(INSPECTORS) && (
											<div>
												<p>There are no users in the database. Please go to the wordpress user admin to create new users, or click the add new user button above to begin.</p>
											</div>
										)}
										{!_.isEmpty(INSPECTORS) && (
											<div>
												<ul ref="inspectors">
													{this.state.inspectorsLoaded.map(function (user) {
														return (
															<li key={user.id}>
																<div><h4><span>{user.last_name}, {user.first_name}</span><a href="#none" onClick={() => this.openCloseInspector(user.id)} className={(this.state.openInspector == user.id) ? "dashicons dashicons-arrow-up-alt2" : "dashicons dashicons-arrow-down-alt2"}></a></h4></div>
																<SlideDown className={'fiq-slidedown'}>
																	{this.state.openInspector == user.id && (
																		<Inspectors user={user} onSelectInspector={this.updateInspector} />
																	)}
																</SlideDown>
															</li>
														);
													}, this)}
													{this.state.loading ? <li className="loading"><h4>Loading Inspectors..</h4></li> : ""}
												</ul>
											</div>
										)}
									</div>
								</div>
							</TabPanel>
						)}
						{(USERROLE == "administrator" || USERROLE == "siteadmin") && (
							<TabPanel>
								<div style={{ maxWidth: 1000 }}>
									<div>
										<div className="filter-list">
											<h3>SiteAdmins</h3>
											{(USERROLE == "administrator" || USERROLE == "siteadmin") && (
												<input type='button' value='Create New Site Admin' className='button button-secondary create-user' onClick={() => this.openModal()} />
											)}
											<input type="text" placeholder="Search" className="search-box" onChange={this.filterSiteAdmins} />
											{_.isEmpty(SITEADMINS) && (
												<div>
													<p>There are no users in the database. Please go to the wordpress user admin to create new users, or click the add new user button above to begin.</p>
												</div>
											)}
											{!_.isEmpty(SITEADMINS) && (
												<ul>
													{this.state.siteadmins.map(function (user) {
														return (
															<li key={user.id}>
																<div><h4><span>{user.company}</span><a href="#none" onClick={() => this.openCloseSiteAdmin(user.id)} className={(this.state.openSiteAdmin == user.id) ? "dashicons dashicons-arrow-up-alt2" : "dashicons dashicons-arrow-down-alt2"}></a></h4></div>
																<SlideDown className={'fiq-slidedown'}>
																	{this.state.openSiteAdmin == user.id && (
																		<SiteAdmins user={user} onSelectSiteAdmin={this.updateSiteAdmin} />
																	)}
																</SlideDown>
															</li>
														);
													}, this)}
												</ul>
											)}
										</div>
									</div>
								</div>
							</TabPanel>
						)}
						{(USERROLE == "administrator" || USERROLE == "trainer") && (
							<TabPanel>
								<div style={{ maxWidth: 1000 }}>
									<div>
										<div className="filter-list">
											<h3>Trainers</h3>
											{(USERROLE == "administrator") && (
												<input type='button' value='Create New Trainer' className='button button-secondary create-user' onClick={() => this.openModal()} />
											)}
											<input type="text" placeholder="Search" className="search-box" onChange={this.filterTrainers} />
											{_.isEmpty(TRAINERS) && (
												<div>
													<p>There are no users in the database. Please go to the wordpress user admin to create new users, or click the add new user button above to begin.</p>
												</div>
											)}
											{!_.isEmpty(TRAINERS) && (
												<ul>
													{this.state.trainers.map(function (user) {
														return (
															<li key={user.id}>
																<div><h4><span>{user.company}</span><a href="#none" onClick={() => this.openCloseTrainer(user.id)} className={(this.state.openTrainer == user.id) ? "dashicons dashicons-arrow-up-alt2" : "dashicons dashicons-arrow-down-alt2"}></a></h4></div>
																<SlideDown className={'fiq-slidedown'}>
																	{this.state.openTrainer == user.id && (
																		<Trainers user={user} onSelectTrainer={this.updateTrainer} />
																	)}
																</SlideDown>
															</li>
														);
													}, this)}
												</ul>
											)}
										</div>
									</div>
								</div>
							</TabPanel>
						)}
						{USERROLE == "administrator" && (
							<TabPanel>
								<div style={{ maxWidth: 1000 }}>
									<h3>Reports</h3>
									<Reports />
								</div>
							</TabPanel>
						)}
					</Tabs>
				</div>
				{(USERROLE == "administrator") && (
					<Modal
						isOpen={this.state.modalIsOpen}
						onAfterOpen={this.afterOpenModal}
						onRequestClose={this.closeModal}
						style={modalStyles}
						contentLabel="Add New User" >

						<form className='add-new-user' onSubmit={(e) => this.addNewUser(e)}>
							<h3>Add New User</h3>
							<a href="#none" className="close-button dashicons dashicons-no" onClick={this.closeModal}><span>close</span></a>
							<span className={this.state.new_user_success ? 'msg-success saved' : 'msg-success'}><i className={'dashicons dashicons-yes-alt'}></i> Success: User created successfully</span>
							<span className={this.state.new_user_error ? 'msg-failed error' : 'msg-failed'}><i className={'dashicons dashicons-warning'}></i> Error: {this.state.new_user_error_msg}</span>
							<div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>User Type</strong></label></div>
									<div className='input'>
										<select name='user_role' className='text-input'>
											<option value="">Select</option>
											<option value="inspector">Inspector</option>
											<option value="trainer">Trainer</option>
											<option value="siteadmin">Site Admin</option>
										</select>
									</div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>First Name</strong></label></div>
									<div className='input'><input name='first_name' type='text' className='text-input' /></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Last Name</strong></label></div>
									<div className='input'><input name='last_name' type='text' className='text-input' /></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Email Address</strong></label></div>
									<div className='input'><input name='user_email' type='text' className='text-input' /></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Company Name</strong></label></div>
									<div className='input'><input name='company' type='text' className='text-input' /></div>
								</div>
								<input type='submit' value='Add New User' className='button button-primary' />
							</div>
						</form >
					</Modal>
				)}
			</div >
		);
	}
}

export default App;
